<template>
    <div v-if="variant" class="progress-bar-compact" :class="`progress-bar-compact--${variant}`" role="progressbar" :aria-valuenow="progressPercentage" aria-valuemin="0" aria-valuemax="100">
        <span class="progress-bar-compact__fill" :style="{ width: progressPercentage + '%' }"></span>
    </div>
    <div v-else class="progress-bar-container">
        <div class="progress-bar">
            <div v-bind:class="progressBarClasses" :style="{ width: progressPercentage + '%' }"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProgressBar',
    props: {
        itemsCompleted: {
            type: Number,
            required: true,
            default: 0
        },
        itemsTotal: {
            type: Number,
            required: true,
            default: 0
        },
        needJustification: {
            type: Boolean,
            required: false,
            default: false
        },
        variant: {
            type: String,
            default: '',
            validator: (value) => ['', 'success', 'warning', 'error', 'cooking'].includes(value)
        }
    },
    computed: {
        progressPercentage() {
            if (!this.itemsTotal || this.itemsTotal === 0) {
                return 0
            }

            return parseInt((this.itemsCompleted / this.itemsTotal) * 100)
        },
        progressBarClasses() {
            return {
                done: this.itemsCompleted === this.itemsTotal,
                progress: this.itemsCompleted < this.itemsTotal,
                justified: this.itemsCompleted < this.itemsTotal && this.needJustification
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.progress-bar-container {
    max-width: 100%;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px 8px;
    position: relative;
    width: 100%;
    background-color: $default-bg-color;
    z-index: 1;
    top: 0;

    @media (min-width: 768px) {
        height: 52px;
    }

    .progress-bar {
        height: 4px;
        z-index: 1;
        background-color: $color-neutral-300;
        width: 100%;
        @include border-radius(10px);
        overflow: auto;
        max-width: 100%;

        .done {
            background-color: $done;
            height: 4px;
        }
        .progress {
            background-color: $progress;
            height: 4px;
        }
        .justified {
            background-color: $warning;
            height: 4px;
        }
    }
}

.progress-bar-compact {
    width: 100%;
    height: 4px;
    overflow: hidden;
    @include border-radius(2px);
    background-color: $color-neutral-300;

    &__fill {
        display: block;
        height: 100%;
        @include border-radius(2px);
        transition: width 1s linear;
    }

    &--success &__fill {
        background-color: $color-success-500;
    }

    &--warning &__fill {
        background-color: $color-warning-500;
    }

    &--error &__fill {
        background-color: $color-error-500;
    }

    &--cooking {
        background-color: $neutro-t30;
        @include border-radius(999px);

        .progress-bar-compact__fill {
            background-color: $warning;
            @include border-radius(999px);
        }
    }
}
</style>
